import { PackagePickerStoreSlice } from './types';
import { reduxKey } from './constants';

function getState(state: any): PackagePickerStoreSlice {
  if (!state[reduxKey]) {
    return {} as any;
  }
  return state[reduxKey];
}

export const getPickerStep = (state: any) => getState(state).pickerStep;

export const getPickerMode = (state: any) => getState(state).pickerMode;

export const getPackages = (state: any) => getState(state).packages;

export const getPackageBenefits = (state: any) =>
  getState(state).packageBenefits;

export const getPackageConfig = (state: any) => getState(state).packageConfig;

export const getFaqs = (state: any) => getState(state).faqs;

export const getSale = (state: any) => getState(state).sale;

export const getGiftUser = (state: any) => getState(state).giftUser;

export const getPackageInfoBanner = (state: any) =>
  getState(state).packageInfoBanner;

export const getCurrentCoreSubscription = (state: any) =>
  getState(state).currentCoreSubscription;
